import axios from "axios";
import React, {
  useState,
  lazy,
  Suspense,
  useEffect,
  createContext,
  useCallback,
} from "react";
import {
  HashRouter,
  BrowserRouter as Router,
  Routes,
  Route,
  useNavigate,
  Navigate,
  Outlet,
} from "react-router-dom";

import { Helmet } from "react-helmet";
import { getTokenData } from "./component/firebase/firebaseConfig";
// import Loader from "./component/Loader/Loader";

// import LocationPermission from './LocationData'
// import "./App.css";
import Something from "./component/Popupimage/somewent.jpeg";
import GovtId from "./component/Upload/Govt_id";
import PageNot from "./component/Pages/PageNotFound/page";
import Loader from "./component/Loader/Loader";
import Header from "./component/Commonpage/Header/Header";
import Footer from "./component/Commonpage/Footer/Footer";
import Swal from "sweetalert2";
import { LoadScript } from "@react-google-maps/api";
// import { useGeolocated } from "react-geolocated";
import { useGeolocated } from "react-geolocated";
import { get } from "jquery";

let navigate = null;

const Home = lazy(() => import("./component/Pages/Home/Home"));

// const Header = lazy(() => import("./component/Commonpage/Header/Header"));
// const Footer = lazy(() => import("./component/Commonpage/Footer/Footer"));
const Aboutus = lazy(() => import("./component/Pages/Aboutus/About"));
const Parking = lazy(() => import("./component/Pages/Parking/Parking"));
const WorkPage = lazy(() => import("./component/Pages/Howwork/Work"));

const Login = lazy(() => import("./component/Auth/Login"));
const SignUp = lazy(() => import("./component/Auth/SignUp"));
const Forget = lazy(() => import("./component/Auth/Forget"));
const ResetPassword = lazy(() => import("./component/Auth/ResetPassword"));

const ContactPage = lazy(() => import("./component/Pages/Contactus/Contact"));
const PrivacyPage = lazy(() =>
  import("./component/Pages/Privacy-policy/Privacy")
);
const TermsAndConditionsPage = lazy(() =>
  import("./component/Pages/TermsCondition/Terms")
);
const FAQ = lazy(() => import("./component/Pages/FQ/FaQ"));
const Blogs = lazy(() => import("./component/Pages/Blogs/Blogs"));
const BlogDetail = lazy(() => import("./component/Pages/Blogs/BlogDetail"));

const Profile = lazy(() => import("./component/User/Profile"));
const ChangePassword = lazy(() => import("./component/User/ChangePassword"));
const SavedVechile = lazy(() => import("./component/User/SavedVechile"));
const UpdateLocation = lazy(() => import("./component/User/UpdateLocation"));

const WelcomeHost = lazy(() => import("./component/Host/WelcomeHost"));
const Host = lazy(() => import("./component/Host/Host "));
const HostBookingHostory = lazy(() =>
  import("./component/Host/BookingHistory/MyBooking")
);
const MyListing = lazy(() => import("./component/Host/MyListing"));
const ManageParking = lazy(() =>
  import("./component/Host/BookingOperation/BookingMange")
);
const Chatss = lazy(() => import("./component/Host/Chatss"));
const BookingDetails = lazy(() => import("./component/Host/BookingDetails"));
const MyBooking = lazy(() =>
  import("./component/User/BookingHistory/MyBooking")
);
const Earning = lazy(() => import("./component/Host/Earning"));
const AddParkingHost = lazy(() =>
  import("./component/Host/BookingOperation/BookingAdd")
);
const ParkingData = lazy(() => import("./component/Pages/ParkingType/Parking"));
const BookingComplete = lazy(() =>
  import("./component/Pages/BookingDetail/BokingComplete")
);
const Paymentcard = lazy(() =>
  import("./component/Pages/BookingDetail/Payment/Paymentcard")
);
const PaymentStripe = lazy(() => import("./component/PaymentSection/Checkout"));
const PaymentBookingComplete = lazy(() =>
  import("./component/PaymentSection/PaymetConfirmPopup")
);
const BookingHistorycancelled = lazy(() =>
  import("./component/User/BookingHistory/cancelledBooking")
);

const Helper = lazy(() => import("./component/User/HelpAndSupport"));

const ChatRoom = lazy(() => import("./component/Pages/Chatroom/chatroom"));
const ChatMsg = lazy(() => import("./component/Pages/Chatroom/chatMsgs"));

const BookingPark = lazy(() =>
  import("./component/Pages/BookingDetail/Booking")
);

const BookingParkDetail = lazy(() =>
  import("./component/Pages/BookingDetail/Bookingdetail")
);

const Favorate = lazy(() => import("./component/User/Favorate"));
const AlertMess = lazy(() => import("./AlertMessage"));
const DeepLink = lazy(() => import("./component/deepLink/DeepLink"));
const ProtectedRoute = () => {
  navigate = useNavigate();
  if (!localStorage.getItem("parqd_token")) {
    return <Navigate to="/login" />;
  }
  return <Outlet />;
};

const googleMapsApiKey = "AIzaSyAZayBd_1QMbIZpRgTc9-QDvtrmuA-w-xI";
const libraries = ["places"];
// const pathname = window.location.hostname.split(".")[2];
const pathname = window.location.hostname.includes(".com");

console.log("pathname", pathname);
// axios.defaults.baseURL = "https://dev.webmobrildemo.com/parqd/api/v1/";
axios.defaults.baseURL = `https://parqd.${
  pathname ? "com" : "in"
}/backend/api/v1/`;
// axios.defaults.baseURL = `https://parqd.com/backend/api/v1/`;

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      if (error.response.status === 400) {
        console.log("Some thing want wrong", error.response);
        console.log("something wrong ------", error.response.data.message);
        // Swal.fire({
        // // title: error.response ? error.response.data : error.message,
        // imageUrl: Something,
        // title: "Something went wrong",
        // imageWidth: 230,
        // imageHeight: 200,
        // imageAlt: "Custom image",
        // });
      } else {
        console.log("sommmm");
      }

      if (
        error.response.data.message == "Unauthenticated User" ||
        error.response.data.message == "Unauthenticated"
      ) {
        console.log("unauth block---");
        console.log("Some clear", error.response);
        localStorage.clear();
        Swal.fire({
          // title: error.response ? error.response.data : error.message,
          imageUrl: Something,
          title: "Unauthenticated User",
          imageWidth: 230,
          imageHeight: 200,
          imageAlt: "Custom image",
        });
        // return(<Navigate to="/" /> )
        navigate("/");
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export const StorelandAndlat = createContext("");

function App() {
  const [coordinates, setCoordinates] = useState({});
  const [error, setError] = useState(null);
  const [loacationUp, setLocationUp] = useState(false);

  const {
    coords,
    isGeolocationAvailable,
    isGeolocationEnabled,
    getCurrentPosition,
    isOptimisticGeolocationEnabled,
  } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumAge: 0,
    },
    userDecisionTimeout: 5000,
    isOptimisticGeolocationEnabled: true,
  });
  // const [loader, setLoading] = useState(false);

  const [AlertMessage, setAlartMessage] = useState();
  const token = localStorage.getItem("parqd_token");
  const getLocationData = () => {
    if (navigator.geolocation) {
      if (
        navigator.connection &&
        (navigator.connection?.effectiveType === "3g" ||
          navigator.connection?.effectiveType === "2g")
      ) {
        alert(
          "Warning: You are on a 3G ,2g connection, which may affect performance."
        );
      } else {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            console.log("NAvigation", position);
            const newCoordinates = {
              user_lat: position.coords.latitude,
              user_lang: position.coords.longitude,
            };
            setCoordinates(newCoordinates);
            setError(null);
            console.log("test---->", navigator);
            // Store the coordinates in localStorage and sessionStorage
            localStorage.setItem("user_lat", newCoordinates.user_lat);
            localStorage.setItem("user_lang", newCoordinates.user_lang);
            sessionStorage.setItem(
              "location_lat",
              JSON.stringify(newCoordinates)
            );
            console.log("location", newCoordinates);
          },
          (error) => {
            setError(error.message);
            localStorage.removeItem("user_lat");
            localStorage.removeItem("user_lang");
            sessionStorage.removeItem("location_lat");
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          }
        );
      }
    } else {
      setError("Geolocation is not supported by this browser.");
    }

    // if (navigator.geolocation) {
    // navigator.geolocation.getCurrentPosition(
    // (position) => {
    // const lat = position.coords.latitude;
    // const lng = position.coords.longitude;
    // const accuracy = position.coords.accuracy;
    // if(accuracy>100)
    // setCoordinates({ lat, lng });
    // console.log("User coordinates:", lat, lng);

    // // Reverse geocode to get address (optional)
    // const geocoder = new window.google.maps.Geocoder();
    // const latlng = { lat, lng };

    // // geocoder.geocode({ location: latlng }, (results, status) => {
    // // if (status === "OK" && results[0]) {
    // // setAddress(results[0].formatted_address);
    // // console.log("User address:", results[0].formatted_address);
    // // } else {
    // // console.error("Geocoder failed due to: " + status);
    // // }
    // // });

    // // Save to storage
    // localStorage.setItem("user_lat", lat);
    // localStorage.setItem("user_lng", lng);
    // sessionStorage.setItem("location_lat", JSON.stringify({ lat, lng }));
    // },
    // (err) => {
    // setError(err.message);
    // },
    // {
    // enableHighAccuracy: true,
    // timeout: 10000,
    // maximumAge: 0,
    // }
    // );
    // } else {
    // setError("Geolocation not supported");
    // }
  };

  const sessionStorageupdate = sessionStorage.getItem("location_lat");
  // const locDataLatlong =  async()=> {
  //   const publicIp = await axios.get(`https://api64.ipify.org?format=json `, {
  //     family: 4, // Force IPv4
  //   });
  //   console.log("publicIp++++++", publicIp);
  //   const ipLocation = await axios.get(
  //     `http://ip-api.com/json/${publicIp?.data?.ip}`
  //   );
  //   console.log("location+++++++++", ipLocation);
  // }

  useEffect(() => {
    // locDataLatlong()
    getLocationData();
  }, []);

  // getLocationData();
  // console.log("loca----", coordinates);

  // useEffect(() => {

  // setTimeout(() => {
  // setLoading(false);
  // }, 0);
  // }, []);

  useEffect(() => {
    if (coords) {
      const newCoordinates = {
        user_lat: coords.latitude,
        user_lang: coords.longitude,
        accuracy: coords.accuracy,
      };
      setCoordinates(newCoordinates);
      console.log("cocoococ--->", newCoordinates);
      console.log("--->", isOptimisticGeolocationEnabled);
      localStorage.setItem("user_lat", newCoordinates.user_lat);
      localStorage.setItem("user_lang", newCoordinates.user_lang);
      sessionStorage.setItem("location_lat", JSON.stringify(newCoordinates));
    } else if (!isGeolocationAvailable) {
      setError("Geolocation is not supported by this browser.");
    } else if (!isGeolocationEnabled) {
      setError("Geolocation is not enabled.");
    }
  }, [coords, isGeolocationAvailable, isGeolocationEnabled]);

  return (
    <>
      {/* <Helmet>
<title>Home</title>
</Helmet> */}
      <Router basename="/">
        <Header />
        {/* <Loader /> */}
        {/* <LoadScript
googleMapsApiKey={googleMapsApiKey}
libraries={libraries}
onLoad={getLocationData}
></LoadScript> */}
        <Suspense
          fallback={
            <div style={{ height: "800px", paddingTop: "10%" }}>
              <Loader />
            </div>
          }
        >
          <Routes>
            <Route element={<ProtectedRoute />}>
              {/* Guest Routes */}
              <Route path="profile" element={<Profile />} />
              <Route path="update_location" element={<UpdateLocation />} />
              <Route path="change_password" element={<ChangePassword />} />
              <Route path="saved_vehicle" element={<SavedVechile />} />
              <Route path="parking/booking" element={<BookingParkDetail />} />
              <Route
                path="parking/booking-details/:id"
                element={<BookingDetails />}
              />
              <Route path="chatroom" element={<ChatRoom />} />
              <Route path="chatroom/message" element={<ChatMsg />} />

              {/* Host Routes */}
              <Route path="welcomehost" element={<WelcomeHost />} />
              <Route path="hosthomes" element={<Host />} />
              <Route path="my-listing" element={<MyListing />} />
              <Route path="earning" element={<Earning />} />
              <Route path="chats" element={<Chatss />} />
              <Route path="booking_details" element={<BookingDetails />} />
              <Route path="add_parking" element={<AddParkingHost />} />
              <Route path="Manage_parking" element={<ManageParking />} />
              <Route path="parking_Complete" element={<BookingComplete />} />
              <Route path="payment_card" element={<Paymentcard />} />
              <Route path="Paymentstripe" element={<PaymentStripe />} />
              <Route path="Sucesspopup" element={<PaymentBookingComplete />} />
              <Route
                path="booking_cancel"
                element={<BookingHistorycancelled />}
              />
              <Route
                path="HostBoking_history"
                element={<HostBookingHostory />}
              />
              <Route path="ownerbooking" element={<MyBooking />} />
            </Route>
            <Route
              path="booking_details/:parking_id"
              element={<BookingDetails />}
            />
            <Route path="parking/:parking_id" element={<BookingPark />} />
            <Route path="parking_type" element={<ParkingData />} />

            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="sign_up" element={<SignUp />} />
            <Route path="login" element={<Login />} />
            <Route path="forget" element={<Forget />} />
            <Route path="reset_password" element={<ResetPassword />} />
            <Route path="upload_govt_id" element={<GovtId />} />
            <Route path="aboutus" element={<Aboutus />} />
            <Route path="parking" element={<Parking />} />
            <Route path="work" element={<WorkPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route
              path="terms-and-condition"
              element={<TermsAndConditionsPage />}
            />
            <Route path="Favorater" element={<Favorate />} />
            <Route path="faq" element={<FAQ />} />
            <Route path="blogs" element={<Blogs />} />
            <Route path="blogs/blog-detail/:name" element={<BlogDetail />} />
            <Route path="helper" element={<Helper />} />
            <Route path="alertMessage" element={<AlertMess />} />
            <Route path="/deep-link/*" element={<DeepLink />} />

            <Route path="*" element={<PageNot />} />
          </Routes>
        </Suspense>
        <Footer />
      </Router>
    </>
  );
}

export default App;
